import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ZoningCode } from '../../../../models';
import { ZoningCodeService } from '../../../../services/zoning-code.service';
import { ZoningCodeStatus } from 'src/app/shared/enums/zoning-code-status';

@Component({
    standalone: false,
    selector: 'app-zoning-code-subform',
    templateUrl: './zoning-code-subform.component.html',
    styleUrls: ['./zoning-code-subform.component.scss']
})
export class ZoningCodeSubformComponent implements OnInit {
    @Output()
    formReady = new EventEmitter<FormGroup>();

    @Input()
    zoningCodeStatuses: ZoningCodeStatus[];

    @Input()
    isZoningCodeOptional: boolean = false;

    public zoningCodes: Array<ZoningCode>;
    zoningCodeForm: FormGroup;

    constructor(private readonly formBuilder: FormBuilder, private readonly zoningCodeService: ZoningCodeService) {}

    getZoningCodes() {
        return this.zoningCodeStatuses
            ? this.zoningCodeService.lastZoningCodesValue?.filter(zc => this.zoningCodeStatuses.indexOf(zc.Status) >= 0)
            : this.zoningCodeService.lastZoningCodesValue;
    }

    static getQueryParams(formGroup: any): any {
        return {
            zoningCodeId: formGroup['zoningCode'] && formGroup['zoningCode'].Id
        };
    }

    ngOnInit() {
        this.zoningCodeForm = this.formBuilder.group({
            zoningCode: ''
        });
        this.formReady.emit(this.zoningCodeForm);
    }
}
